import React from 'react';
import { createRoot } from 'react-dom/client';
import { InlinePinsCounter } from './InlinePinsCounter';
import { PinsCounter } from './PinsCounter';

// Função para renderizar o contador inline
export function renderPinsCounter() {
  const container = document.getElementById('pins-counter-root');
  
  if (container) {
    try {
      // Limpar o container
      container.innerHTML = '';
      
      // Criar root do React
      const root = createRoot(container);
      
      // Em index.html usar o contador dinâmico da view 'pins'.
      // Se quiser forçar inline estático, altere para InlinePinsCounter
      const isIndex = window.location.pathname.endsWith('/') || window.location.pathname.endsWith('/index.html');
      root.render(React.createElement(isIndex ? PinsCounter : InlinePinsCounter));
      
      console.log('✅ Contador de pins renderizado com sucesso!');
    } catch (error) {
      console.error('❌ Erro ao renderizar contador de pins:', error);
      // Fallback: mostrar número estático se der erro
      container.innerHTML = '<span style="color: #f9d70b; font-size: 1.2rem; font-weight: bold; font-family: \'Arial Black\', sans-serif;">0</span>';
    }
  } else {
    console.warn('⚠️ Elemento #pins-counter-root não encontrado');
  }
}

// Auto-executar se estiver no browser
if (typeof window !== 'undefined') {
  // Aguardar o DOM estar pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderPinsCounter);
  } else {
    renderPinsCounter();
  }
}
